"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPLEMENTAL_QUERY_VARIABLES = void 0;
exports.SUPPLEMENTAL_QUERY_VARIABLES = [
    // "reportingDate" is required parameter that's part of Reporting worklease
    // so will always be available. Using dummy value as this is purely for validation
    // purposes (technically "reportingDate" is not known yet at this point)
    { name: 'reportingDate', value: '2000-01-01', parseNumber: true },
];
//# sourceMappingURL=utils.js.map